export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=405920de0defe8a2f26d58b206a9e320245bbef658&name=revalidateCommunity!'